export type AppView = 'main' | 'app' | 'alt' | 'timeslotstoday';
export type RouteParams = {
  operation: string;
};
export type OperationPage =
  'start' | 'services' | 'timeslots' | 'contact' | 'confirm';

export type FollowUpPage =
  'followup-timeslots' | 'followup-contact' | 'followup-confirm';

export type AppPage =
  | OperationPage
  | FollowUpPage
  | 'questions'
  | 'questions-confirmed'
  | 'service-unavailable'
  | 'not-found';

export const isOperationPage = (page: AppPage): page is OperationPage => {
  return (
    page === 'start' ||
    page === 'services' ||
    page === 'timeslots' ||
    page === 'contact' ||
    page === 'confirm'
  );
};
